import { createAction, props } from '@ngrx/store';
import { Activity } from 'src/app/models/activity/activity';
import { BookingMemberDetailExtend } from 'src/app/models/booking-member/booking-member-detail-extend';
import { Calendar } from 'src/app/models/calendar/calendar';
import { ScheduleInfoBasicDto } from 'src/app/models/calendar/schedule/schedule-info-basic';
import { ScheduleTransformer } from '@models/calendar/schedule/schedule';
import { StaffBasicDto } from 'src/app/models/staff/staff-basic-dto';

export const schedulesList = createAction(
    '[Schedules] list'
);

export const schedulesListSuccess = createAction(
    '[Schedules] list success',
    props<{ schedules: Calendar[] }>()
);

export const staffList = createAction(
    '[staff] list'
);

export const staffListSuccess = createAction(
    '[staff] list success',
    props<{ staff: StaffBasicDto[] }>()
);

export const activityList = createAction(
    '[Activity] list'
);

export const activityListSuccess = createAction(
    '[Activity] list success',
    props<{ activities: Activity[] }>()
);

export const setSchedule = createAction(
    '[Set Schedule] set',
    props<{ schedule: ScheduleInfoBasicDto; date?: Date }>()
);

export const bookingMembersList = createAction(
    '[Booking Members] list',
    props<{ idSchedule: number }>()
);

export const bookingMembersListSuccess = createAction(
    '[Booking Members] list success',
    props<{ bookingMembers: BookingMemberDetailExtend }>()
);


export const updateDateSchedule = createAction(
    '[Schedule] update date success',
    props<{ date: Date; schedule: ScheduleTransformer }>()
);

export const updateSchedule = createAction(
    '[Schedule] update schedule',
    props<{ schedule: ScheduleTransformer }>()
);

export const updateScheduleFailure = createAction(
    '[Schedule] Update Schedule Failure',
    props<{ errorMssg: string }>()
);

export const updateScheduleSuccess = createAction(
    '[Schedule] Update Schedule Success',
    props<{ success: boolean }>()
);


